var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"id":"payment-form"}},[_c('div',{ref:"card",staticClass:"form-control m-2"})]),_c('b-col',[_c('n-button',{attrs:{"type":"success","size":"sm"},on:{"click":_vm.createCardToken}},[_vm._v("Add Card")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }